export const CARDS_REQUEST = "CARDS_REQUEST";
export const CARDS_SUCCESS = "CARDS_SUCCESS";
export const CARDS_ERROR = "CARDS_ERROR";

export const CARDS_ACCS_REQUEST = "CARDS_ACCS_REQUEST";
export const CARDS_ACCS_SUCCESS = "CARDS_ACCS_SUCCESS";
export const CARDS_ACCS_ERROR = "CARDS_ACCS_ERROR";

export const CARDS_ACCS_CREATE = "CARDS_ACCS_CREATE";

export const CARDS_BALANCE_REQUEST = "CARDS_BALANCE_REQUEST";
export const CARDS_BALANCE_SUCCESS = "CARDS_BALANCE_SUCCESS";
export const CARDS_BALANCE_ERROR = "CARDS_BALANCE_ERROR";

export const CARDS_CLIENT_BALANCE_REQUEST = "CARDS_CLIENT_BALANCE_REQUEST";
export const CARDS_CLIENT_BALANCE_SUCCESS = "CARDS_CLIENT_BALANCE_SUCCESS";
export const CARDS_CLIENT_BALANCE_ERROR = "CARDS_CLIENT_BALANCE_ERROR";

export const CARDS_TRANSACTIONS_REQUEST = "CARDS_TRANSACTIONS_REQUEST";
export const CARDS_TRANSACTIONS_SUCCESS = "CARDS_TRANSACTIONS_SUCCESS";
export const CARDS_TRANSACTIONS_ERROR = "CARDS_TRANSACTIONS_ERROR";

export const CARDS_UPDATE_REQUEST = "CARDS_UPDATE_REQUEST";
export const CARDS_UPDATE_SUCCESS = "CARDS_UPDATE_SUCCESS";
export const CARDS_UPDATE_ERROR = "CARDS_UPDATE_ERROR";
export const CARDS_UPDATE_RESET = "CARDS_UPDATE_RESET";

export const CARDS_BLOCK_REQUEST = "CARDS_BLOCK_REQUEST";
export const CARDS_BLOCK_SUCCESS = "CARDS_BLOCK_SUCCESS";
export const CARDS_BLOCK_ERROR = "CARDS_BLOCK_ERROR";
export const CARDS_BLOCK_RESET = "CARDS_BLOCK_RESET";

export const CARDS_UNBLOCK_REQUEST = "CARDS_UNBLOCK_REQUEST";
export const CARDS_UNBLOCK_SUCCESS = "CARDS_UNBLOCK_SUCCESS";
export const CARDS_UNBLOCK_ERROR = "CARDS_UNBLOCK_ERROR";
export const CARDS_UNBLOCK_RESET = "CARDS_UNBLOCK_RESET";

export const CARDS_MONEY_TO_ACC_REQUEST = "CARDS_MONEY_TO_ACC_REQUEST";
export const CARDS_MONEY_ACC_TO_ACC_REQUEST = "CARDS_MONEY_ACC_TO_ACC_REQUEST";

export const CARDS_FUEL_TO_ACC_REQUEST = "CARDS_FUEL_TO_ACC_REQUEST";
export const CARDS_FUEL_ACC_TO_ACC_REQUEST = "CARDS_FUEL_ACC_TO_ACC_REQUEST";

export const CARDS_GET_REPORT = "CARDS_GET_REPORT";

export const SIMPLE_POST = "SIMPLE_POST";

export const CARDS_CARD_USER_LOGIN_REQUEST = "CARDS_CARD_USER_LOGIN_REQUEST";
export const CARDS_CARD_USER_LOGIN_SUCCESS = "CARDS_CARD_USER_LOGIN_SUCCESS";
export const CARDS_CARD_USER_LOGIN_ERROR = "CARDS_CARD_USER_LOGIN_ERROR";

export const CARDS_NEW_CARD_USER_LOGIN_REQUEST = "CARDS_NEW_CARD_USER_LOGIN_REQUEST";
export const CARDS_NEW_CARD_USER_LOGIN_SUCCESS = "CARDS_NEW_CARD_USER_LOGIN_SUCCESS";
export const CARDS_NEW_CARD_USER_LOGIN_ERROR = "CARDS_NEW_CARD_USER_LOGIN_ERROR";

export const CARDS_CARD_USER_REQUEST = "CARDS_CARD_USER_REQUEST";
export const CARDS_CARD_USER_SUCCESS = "CARDS_CARD_USER_SUCCESS";
export const CARDS_CARD_USER_ERROR = "CARDS_CARD_USER_ERROR";


